module.exports = __webpack_public_path__ + "img/goodStanding.17845022.png";